import React, { useState } from "react";
import { SectionWrapper } from "features/AdminPanel/modules/SectionWrapper/SectionWrapper";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";

export const TableHeader = ({
  imgSrc,
  title,
}: {
  imgSrc: string;
  title: string;
}) => {
  return (
    <SectionWrapper
      className="!tw-py-2"
      config={{
        title: (
          <div className="tw-text-[#272522] tw-text-[18px] tw-font-medium tw-leading-normal tw-flex tw-items-center tw-gap-2">
            <ExlyImage
              className="tw-w-6 tw-aspect-square tw-object-contain"
              src={imgSrc}
            />
            {title}
          </div>
        ),
      }}
    />
  );
};
